import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const fmt = (n) => {
  const v = Number(n || 0);
  return new Intl.NumberFormat("he-IL", { maximumFractionDigits: 0 }).format(v);
};

export const fmtShekel = (n) => `${fmt(n)} ₪`;

export const MONTHS_HE = [
  "ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני",
  "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר",
];

export const todayISO = () => new Date().toISOString().slice(0, 10);

/**
 * Extract tax portion from a "tax-inclusive" amount.
 * If the amount already includes the tax, this returns the tax component:
 *   taxIncluded(5310, 0.18) → 810   (5310 = 4500 net + 810 VAT)
 * Formula: amount × rate / (1 + rate)
 */
export const taxIncluded = (amount, rate) => {
  const a = Number(amount) || 0;
  const r = Number(rate) || 0;
  return (a * r) / (1 + r);
};

/**
 * Returns an ISO date string that falls within the given month/year.
 * If today's month/year matches, returns today; otherwise returns the 1st of that month
 * (or capped to the last day of that month when today's day exceeds it).
 */
export const dateInPeriod = (month, year) => {
  const t = new Date();
  if (t.getMonth() + 1 === month && t.getFullYear() === year) {
    return t.toISOString().slice(0, 10);
  }
  const lastDay = new Date(year, month, 0).getDate();
  const day = Math.min(t.getDate(), lastDay);
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
};

export const dateToMonthYear = (iso) => {
  const [y, m] = iso.split("-");
  return { month: parseInt(m, 10), year: parseInt(y, 10) };
};
